import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  CardHeader,
  Badge,
  Table,
  Alert
} from 'reactstrap';

const CustomerQuotes = ({ pb, customerId }) => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchQuotes = async () => {
      if (!customerId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        // PocketBase SDK'yı kullanarak veri çekme
        const resultList = await pb.collection('invoices').getList(1, 50, {
          filter: `customer = "${customerId}"`
        });
        
        console.log("Customer ID:", customerId);
        console.log('Fetched quotes:', resultList);
        
        if (resultList && resultList.items) {
          setQuotes(resultList.items);
        } else {
          setQuotes([]);
        }
      } catch (error) {
        console.error('Error fetching quotes:', error);
        setError(error.message || 'Teklifler yüklenirken bir hata oluştu');
        setQuotes([]);
      } finally {
        setLoading(false);
      }
    };

    // PocketBase bağlantısını kontrol ediyoruz
    if (!pb) {
      setError('PocketBase bağlantısı bulunamadı');
      setLoading(false);
      return;
    }

    fetchQuotes();
  }, [customerId, pb]);

  const getStatusBadgeColor = (status) => {
    const statusColors = {
      'Taslak': 'warning',
      'Onaylandı': 'success',
      'Reddedildi': 'danger',
      'Beklemede': 'info',
      'İptal Edildi': 'secondary'
    };
    return statusColors[status] || 'primary';
  };

  // Para birimi formatlaması
  const formatCurrency = (amount, currency = 'TRY') => {
    if (!amount) return '0.00';
    
    try {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (error) {
      return `${amount} ${currency}`;
    }
  };

  if (loading) {
    return (
      <div className="text-center p-3">
        <div className="spinner-border text-primary m-1" role="status">
          <span className="sr-only">Yükleniyor...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <Alert color="danger">
        <i className="ri-error-warning-line me-2"></i>
        {error}
      </Alert>
    );
  }

  return (
    <Card>
      <CardHeader className="d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">Teklifler</h5>
        <span className="badge bg-secondary">
          Toplam: {quotes.length}
        </span>
      </CardHeader>
      <CardBody>
        <div className="table-responsive">
          <Table className="table-hover table-nowrap mb-0">
            <thead>
              <tr>
                <th>Teklif No</th>
                <th>Başlık</th>
                <th>Tutar (Tüm Para Birimleri)</th>
                <th>Oluşturma Tarihi</th>
                <th>Geçerlilik Tarihi</th>
                <th>Durum</th>
              </tr>
            </thead>
            <tbody>
              {quotes.length > 0 ? (
                quotes.map((quote) => (
                  <tr key={quote.id}>
                    <td>{quote.invoice_number}</td>
                    <td>{quote.title}</td>
                    <td>
                      {quote.total_amount && typeof quote.total_amount === 'object' ? (
                        Object.entries(quote.total_amount).map(([currency, amount]) => (
                          <div key={currency}>
                            {formatCurrency(amount, currency)}
                          </div>
                        ))
                      ) : (
                        'Tutar bilgisi bulunamadı'
                      )}
                    </td>
                    <td>{new Date(quote.due_date).toLocaleDateString('tr-TR')}</td>
                    <td>
                      {quote.valid_until ? 
                        new Date(quote.valid_until).toLocaleDateString('tr-TR') : 
                        '-'
                      }
                    </td>
                    <td>
                      <Badge color={getStatusBadgeColor(quote.status)}>
                        {quote.status}
                      </Badge>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center text-muted py-4">
                    <i className="ri-file-list-3-line fs-24 mb-2 d-block"></i>
                    Henüz teklif bulunmuyor
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};

CustomerQuotes.propTypes = {
  pb: PropTypes.object.isRequired,
  customerId: PropTypes.string.isRequired
};

export default CustomerQuotes;